export const instructions = [
   'Откройте приложение WhatsApp на вашем телефоне',
   'Перейдите в раздел "Связанные устройства" и отсканируйте QR-код'
]